import {
  ILoyaltyRewardsResponse,
  ILoyaltyGoalResponse,
  ILoyaltyHistoryResponse,
  ILoyaltyProductResponse,
  ILoyaltyProductSimulateResponse,
  ILoyaltyProductListToSend,
  ILoyaltyWithdrawResponse,
  ILoyaltySendWithdrawResponse,
  ILoyaltySendWithdrawBody,
  ILoyaltyRewardTotals
} from '../../store/ducks/loyalty/types';
import { EGerdauService } from '../EGerdauService';
import {
  ECustomerAuthorizationEndpoints,
  customersAuthorizationApi
} from '../api';

export class LoyaltyService extends EGerdauService {
  async loadLoyaltyRewards(
    loyaltyCustomers: string[]
  ): Promise<ILoyaltyRewardsResponse> {
    const headers = super.getHeaders();
    const objectToSend = {
      customersIds: loyaltyCustomers
    };
    const response = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.LOYALTY_REWARD}`,
      objectToSend,
      { headers }
    );
    const total: ILoyaltyRewardTotals = response.data.body.total;
    if (total.total_coins < 0.01) {
      total.total_coins = 0;
    }
    return {
      monthly_coins: response.data.body.monthly_coins,
      total: total
    };
  }
  async loadLoyaltyGoal(
    loyaltyCustomers: string[]
  ): Promise<ILoyaltyGoalResponse> {
    const headers = super.getHeaders();
    const objectToSend = {
      customersIds: loyaltyCustomers
    };
    const response = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.LOYALTY_GOAL}`,
      objectToSend,
      { headers }
    );
    return {
      monthly_goal: response.data.body
    };
  }
  async loadLoyaltyWithdraw(): Promise<ILoyaltyWithdrawResponse> {
    const headers = super.getHeaders();
    const response = await customersAuthorizationApi.get(
      ECustomerAuthorizationEndpoints.LOYALTY_WITHDRAW,
      { headers }
    );
    return {
      status: response.data.status,
      success: response.data.success,
      body: response.data.body
    };
  }
  async loadLoyaltyProductSimulate(
    loyaltyCustomers: string,
    productList: ILoyaltyProductListToSend[]
  ): Promise<ILoyaltyProductSimulateResponse> {
    const headers = super.getHeaders();
    const objectToSend = {
      client_id: loyaltyCustomers,
      product_list: productList
    };
    const response = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.LOYALTY_PRODUCT_SIMULATE}`,
      objectToSend,
      { headers }
    );
    return {
      monthly_target: response.data.monthly_target,
      quarterly_target: response.data.quarterly_target,
      simulation_tonne: response.data.simulation_tonne
    };
  }
  async loadLoyaltyProduct(sku: string): Promise<ILoyaltyProductResponse> {
    const headers = super.getHeaders();
    const response = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.LOYALTY_PRODUCT}?sku=${sku}`,
      { headers }
    );
    return {
      product_search: response.data.product_search
    };
  }
  async loadLoyaltyHistory(
    loyaltyCustomers: string[]
  ): Promise<ILoyaltyHistoryResponse> {
    const headers = super.getHeaders();
    const objectToSend = {
      customersIds: loyaltyCustomers
    };
    const response = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.LOYALTY_HISTORY}`,
      objectToSend,
      { headers }
    );
    return {
      history_body: response.data.body
    };
  }
  async loadLoyaltySendWithdraw(
    loyaltyCustomers: string[],
    requestBody: ILoyaltySendWithdrawBody
  ): Promise<ILoyaltySendWithdrawResponse> {
    const headers = super.getHeaders();
    const response = await customersAuthorizationApi.post(
      `${
        ECustomerAuthorizationEndpoints.LOYALTY_SEND_WITHDRAW
      }?customersIds=${loyaltyCustomers.join(',')}`,
      requestBody,
      { headers }
    );
    return {
      success: response.data.success,
      status: response.data.status,
      body: response.data.body
    };
  }
}
